import { combineReducers, createStore } from "@reduxjs/toolkit";
import { reducer as toastrReducer } from "react-redux-toastr";
import { reducer as appReducer } from "./app-reducer";
const reducers = {
  app: appReducer,
  toastr: toastrReducer, // <- Mounted at toastr.
};
const reducer = combineReducers(reducers);
const store = createStore(reducer);

export default store;
